import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
const omRoomImages = [
  "/images/OM Edited/DSC03211.webp",
  "/images/OM Edited/DSC03220.webp",
  "/images/OM Edited/DSC03342.webp",
  "/images/OM Edited/DSC03096.webp",
  "/images/OM Edited/DSC02964.webp",
  "/images/OM Edited/DSC02892.webp"
];
const OmRooms = () => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-3xl text-center">
                    <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Zimmer in Hiru Om
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Ein ruhiger Rückzugsort in einem Doppelzimmer
                    </h2>
                    <p className="mt-5 font-mulish text-base leading-8 text-gray-600 sm:text-lg">
                        Aus 12 komfortablen Zimmern beginnt ein Aufenthalt, der Körper und Geist langsam zur Ruhe kommen lässt.
                    </p>
                </div>

                <article className="mx-auto mt-12 grid max-w-7xl overflow-hidden rounded-[26px] bg-[#fbfaf7] shadow-[0_22px_65px_rgba(16,38,26,0.1)] lg:grid-cols-[1.1fr_0.9fr]">
                    <button
    type="button"
    className="group relative block aspect-[4/3] min-h-[320px] w-full overflow-hidden bg-[#f3eee7] text-left lg:aspect-auto lg:min-h-[560px]"
    onClick={() => setIsGalleryOpen(true)}
    aria-label="Bilder des Doppelzimmers in Hiru Om ansehen"
  >
                        <img
    src={omRoomImages[0]}
    alt="Doppelzimmer in Hiru Om"
    className="object-cover transition-transform duration-700 group-hover:scale-[1.04]" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/75 via-transparent to-transparent" />
                        <div className="absolute inset-x-6 bottom-6 flex items-end justify-between gap-4 text-white sm:inset-x-8">
                            <div>
                                <p className="font-mulish text-xs font-semibold uppercase tracking-[0.22em] text-amber-200">12 Zimmer</p>
                                <h3 className="mt-2 font-serif text-3xl font-semibold sm:text-4xl">Doppelzimmer</h3>
                            </div>
                            <span className="rounded-full bg-white/20 px-3 py-2 text-xs font-semibold backdrop-blur-md">Bilder ansehen</span>
                        </div>
                    </button>

                    <div className="p-6 sm:p-8 lg:p-10">
                        <p className="font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                            Alle 12 Zimmer, verteilt auf zwei Etagen, bieten großzügigen Platz von etwa 38 Quadratmetern. Von Ihrem eigenen Balkon oder Terrasse aus genießen Sie einen Blick auf den schönen Garten und die ruhige See des Indischen Ozeans.
                        </p>
                        <p className="mt-5 font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                            In den stilvoll gestalteten Zimmern mit dem charakteristischen Hiru-Design können Sie die Aussicht genießen, die Energie der Bodhi-Bäume spüren und eine entspannte Zeit in vollen Zügen genießen. Auch für Alleinreisende ist eine Nutzung als Einzelzimmer möglich.
                        </p>
                        <ul className="mt-6 space-y-2 border-l-2 border-amber-300 pl-4 font-mulish text-sm leading-7 text-[#475569] sm:text-base">
                            <li>Im Zimmer inklusive: Föhn, Telefon, Safe, kostenloses WLAN.</li>
                            <li>Für einen gesunden Aufenthalt: Dusche, WC, Deckenventilator, Klimaanlage (kostenpflichtig), Moskitonetz.</li>
                            <li>Außerdem stehen ayurvedische Annehmlichkeiten und Yogamatten zur Verfügung.</li>
                        </ul>
                        <button
    type="button"
    onClick={() => setIsGalleryOpen(true)}
    className="mt-7 inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]"
  >
                            Zimmerfotos ansehen
                        </button>
                    </div>
                </article>
            </div>

            <Lightbox
    open={isGalleryOpen}
    close={() => setIsGalleryOpen(false)}
    slides={omRoomImages.map((image) => ({ src: image }))}
    plugins={[Thumbnails, Zoom]}
    thumbnails={{ position: "bottom", border: 0, vignette: true }}
    zoom={{ maxZoomPixelRatio: 3 }}
    carousel={{ finite: false }}
  />
        </section>;
};
export default OmRooms;
